import React from 'react';
import css from './SupportButtonPopup.module.scss';
import { Button, Icon } from '@innovationnorway/cl-react';
import { useTranslation } from 'react-i18next';

type SupportButtonPopupProps = {
  show: boolean;
  deactivate: () => void;
};

const SupportButtonPopup: React.FC<SupportButtonPopupProps> = ({ show, deactivate }) => {
  const { t: tCommon } = useTranslation('common');

  const classNames = show ? css['support-button-popup'] : css['support-button-popup--hide'];

  return (
    <div className={classNames}>
      <div className={css['support-button-popup__top-container']}>
        <p className="font-weight--bold">{tCommon('contactSupport')}</p>
        <Button
          type="button"
          icon
          variant="tertiary"
          className={css['support-button-popup__top-container--close']}
          aria-label={tCommon('close')}
          onClick={() => deactivate()}
        >
          <Icon prefix="fasr" iconName="xmark" />
        </Button>
      </div>
      <p className={css['support-button-popup__email']}>
        {tCommon('contactUsByEmail')}: <a href="mailto:support@enveiinn.no">support@enveiinn.no</a>
      </p>
    </div>
  );
};

export default SupportButtonPopup;
